export const findCityOfProvince = (
  provinces: Array<IProvince> | undefined,
  selectedStateId: number,
) => {
  return provinces
    ? provinces
        .find(item => Number(item.id) === Number(selectedStateId))
        ?.cities?.map(item => {
          return {
            label: item.name,
            value: item.id,
          };
        })
    : [];
};
export const ProvincesToOption = (
  provinces: Array<IProvince>,
): Array<IOption> => {
  return provinces
    ?.map(item => {
      return {
        value: item.id,
        label: item.name,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};
